// extracted by mini-css-extract-plugin
module.exports = {"EmbedVideo":"EmbedVideo_EmbedVideo__20jQ5","Active":"EmbedVideo_Active__25uPS","Play":"EmbedVideo_Play__3qpJJ"};